module.exports = __webpack_public_path__ + "static/media/qualitas-phone.a62f756b.svg";